import { Component } from '@angular/core';
import {AppService} from './app.service'
import { Router, Params, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'login-form',
  providers: [AppService],
  styleUrls: ['./login.component.css'],
  template: `
    <div class="login-container">
        <div class="login-card">
            <h1 class="login-title">Enter Verification Code</h1>
            
            <div class="verification-info">
                <p class="verification-text">We've sent a 6-digit verification code to</p>
                <p class="phone-display">{{maskedPhone}}</p>
            </div>
            
            <input type="hidden" [(ngModel)]="loginData.username" />
            
            <div class="form-group">
                <label class="form-label">Verification Code</label>
                <input 
                    class="form-input code-input" 
                    type="tel" 
                    inputmode="numeric"
                    pattern="[0-9]*"
                    autocomplete="one-time-code"
                    placeholder="Enter 6-digit code"
                    maxlength="6"
                    (keyup.enter)="login()" 
                    [(ngModel)]="loginData.password"
                />
                <div class="form-hint">Check your SMS messages</div>
            </div>
            
            <button class="login-button" (click)="login()" type="submit">
                Verify & Login
            </button>
            
            <div class="action-links">
                <button class="resend-link" (click)="resendCode()" type="button">
                    Didn't receive code? Resend
                </button>
                <a href="/#/prelogin" class="back-link">Back to Login</a>
            </div>
            
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>`
})
export class LoginComponent {
    public loginData = {username: "", password: ""};
    public maskedPhone: string = "";

    typeSelected: string;

    constructor(private _service:AppService, private _router: ActivatedRoute, private router: Router, private spinnerService: NgxSpinnerService) {
        this.typeSelected = 'ball-fussion';
    }

    ngOnInit() {
        this.loginData.username = this._router.snapshot.params['username'];
        this.maskedPhone = this.maskPhoneNumber(this.loginData.username);
    }

    maskPhoneNumber(phone: string): string {
        if (!phone) return "";
        if (phone.length <= 4) return phone;
        const masked = phone.substring(0, 3) + "****" + phone.substring(phone.length - 3);
        return masked;
    }

    public showSpinner(): void {
        this.spinnerService.show();
    
        // setTimeout(() => {
        //  this.spinnerService.hide();
        // }, 5000); // 5 seconds
      }

    register() {
        this.router.navigate(['/register']);
    }

    resendCode() {
        this.showSpinner();
        alert('New verification code has been sent to your phone');
        this.spinnerService.hide();
        // Could implement actual resend logic here
        // this._service.preLogin({phone: this.loginData.username, pin: "resend", recaptchaResponse: ""});
    }
 
    login() {
        this.showSpinner()
        if (this.loginData.username.indexOf('+') != -1) {
            this.loginData.username = this.loginData.username.substring(1);
        }
        if (this.loginData.username.substring(0,2) == "00") {
            this.loginData.username = this.loginData.username.substring(2);
        }
        console.log(this.loginData);
        this._service.obtainAccessToken(this.loginData);
    }
}
